"use strict";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";
import {
    loginAuthComplete,
    logoutAuthComplete,
    ajaxError,
    refreshTokenError,
    authUserProfileDetailsComplete,
    refreshTokenAuthComplete,
    preRegistrationComplete,
    preRegistrationActivateComplete,
    forgotPasswordEmailVeryficationComplete,
    forgotPasswordResetPasswordComplete,
    forgotPasswordResetPasswordInitialComplete,
    sendOtpComplete,
    reSendOtpComplete,
    sendOtpRequest,
    changePasswordComplete,
    sendOTPAfterLoginComplete,
    sendOTPAfterLoginRequest,
    changePasswordPreAuthDetails,
    changePasswordPreMobileDetails,
    changeMobileNumberComplete,
    profilePictureUploadComplete,
    profileNotificationChangeComplete,
    profileChangeHomeAddressComplete,
    changeProfileNameComplete,
    getUSerDetailsComplete,
    getParticipantProfileComplete,
    getParticipantProfileRequest,
    subscribeComplete,
    campaignGetAreaManagerDealersRequest,
    campaignGetParticipantsByDealerRequest,
    userDeviceComplete,
} from "../_actions";
import {
    authConstants,
    requestTypes,
    otpTypeConstants,
    participantTypeIds,
} from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";

export const loginAuthEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_LOGIN_REQUEST),
        mergeMap((action) => {
            const { navigate, requetedUrl, ...payload } = action.payload;
            return ajax
                .post(
                    "/api/auth/login",
                    {
                        email: payload.email,
                        password: payload.password,
                        validateOtp: payload.validateOtp,
                        otp: action.payload.otp,
                        browserFingerprint: action.payload.browserFingerprint,
                        rememberBrowser: action.payload.rememberBrowser,
                    },
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        if (ajaxResponse.response.data.otpRequired) {
                            if (ajaxResponse.response.data.otpVerified) {
                                navigate(requetedUrl);

                                return of(
                                    loginAuthComplete(ajaxResponse.response),
                                );
                            } else {
                                return of(
                                    sendOtpRequest({
                                        userId: ajaxResponse.response.data
                                            .userId,
                                        timeStamp:
                                            ajaxResponse.response.data
                                                .timeStamp,
                                        otpTypeId:
                                            otpTypeConstants.AUTH_TYPE_LOGIN,
                                        rememberBrowser: false,
                                        browserFingerprint:
                                            action.payload.browserFingerprint,
                                        navigate,
                                    }),

                                    loginAuthComplete(ajaxResponse.response),
                                );
                            }
                        } else {
                            navigate(requetedUrl);

                            return of(loginAuthComplete(ajaxResponse.response));
                        }
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const forgotPasswordResetPasswordEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.FORGOT_PASSWORD_RESET_PASSWORD_REQUEST),
        mergeMap((action) => {
            const { navigate, form, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/auth/forgotPasswordResetPassword",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        if (ajaxResponse.response.data.otpVerified) {
                            navigate("/");

                            return of(
                                forgotPasswordResetPasswordComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        } else {
                            return of(
                                sendOtpRequest({
                                    userId: payload.userId,
                                    rememberBrowser: false,
                                    browserFingerprint:
                                        payload.browserFingerprint,

                                    timeStamp:
                                        ajaxResponse.response.data.timeStamp,
                                    otpTypeId:
                                        otpTypeConstants.AUTH_TYPE_FOGOT_PASSWORD,
                                    navigate,
                                }),

                                forgotPasswordResetPasswordComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        }
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const preRegistrationActivateEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.PRE_REGISTRATION_ACTIVATE_REQUEST),
        mergeMap((action) => {
            const { navigate, ...payload } = action.payload;
            return ajax
                .post(
                    "/api/auth/pre-registration-activate",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        navigate("/");
                        return preRegistrationActivateComplete(
                            ajaxResponse.response,
                        );
                    }),
                    // map((ajaxResponse) => {
                    // if (ajaxResponse.response.data.otpVerified) {
                    // navigate("/");

                    // return
                    //     preRegistrationActivateComplete(
                    //         ajaxResponse.response,
                    //     ),

                    // } else {
                    //     return of(
                    //         sendOtpRequest({
                    //             userId: payload.userId,
                    //             rememberBrowser: false,
                    //             browserFingerprint:
                    //                 payload.browserFingerprint,
                    //             timeStamp:
                    //                 ajaxResponse.response.data.timeStamp,
                    //             otpTypeId:
                    //                 otpTypeConstants.AUTH_TYPE_ACCOUNT_ACTIVATION,
                    //             navigate,
                    //         }),

                    //         preRegistrationActivateComplete(
                    //             ajaxResponse.response,
                    //         ),
                    //     );
                    // }
                    // }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const sendOptEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.SEND_OTP_REQUEST),
        mergeMap((action) => {
            const {
                navigate,
                otpTypeId,
                timeStamp,
                userId,
                rememberBrowser,
                browserFingerprint,
            } = action.payload;

            return ajax
                .post(
                    "/api/auth/sendOtp",
                    {
                        timeStamp,
                        userId,
                        otpTypeId,
                        rememberBrowser,
                        browserFingerprint,
                    },
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        navigate(
                            "/auth/otp-verification/" +
                                otpTypeId +
                                "/" +
                                userId,
                        );

                        return sendOtpComplete(ajaxResponse.response);
                    }),

                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const reSendOptEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.RE_SEND_OTP_REQUEST),
        mergeMap((action) => {
            const {
                otpTypeId,
                userId,
                rememberBrowser,
                browserFingerprint,
                phoneNumber,
            } = action.payload;

            const payload = {
                userId,
                otpTypeId,
                rememberBrowser,
                browserFingerprint,
            };

            if (otpTypeConstants.AUTH_TYPE_ADD_ACCOUNT == otpTypeId) {
                payload.phoneNumber = phoneNumber;
            }

            return ajax
                .post(
                    "/api/auth/reSendOtp",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return reSendOtpComplete(ajaxResponse.response);
                    }),

                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const authUserProfileDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_USER_PROFILE_DEATAILS_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/auth/user-profile",

                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return authUserProfileDetailsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const logoutAuthEpic = (actions$) =>
    actions$.pipe(
        ofType(authConstants.AUTH_LOGOUT_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/auth/logout",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        clearCookieData();
                        localStorage.removeItem("pre-path")
                        action.payload.navigate("/");
                        return logoutAuthComplete(ajaxResponse.response);
                    }),

                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );

export const getNewActionTokenEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_GET_REFRESH_TOKEN_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/auth/get-refreshtoken",

                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return refreshTokenAuthComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(refreshTokenError(error))),
                ),
        ),
    );
};

export const reRegistrationEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.PRE_REGISTRATION_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/auth/pre-registration",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) =>
                        preRegistrationComplete(ajaxResponse.response),
                    ),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const sendOTPAfterLoginEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_SEND_OTP_AFTER_LOGIN_REQUEST),
        mergeMap((action) => {
            const {
                otpTypeId,
                rememberBrowser,
                browserFingerprint,
                showOtpFlow,
                timeStamp,
                showOtpMobileFlow,
                flowType,
            } = action.payload;

            return ajax
                .post(
                    "/api/auth/send-otp-after-login",
                    {
                        otpTypeId,
                        rememberBrowser,
                        browserFingerprint,
                        timeStamp,
                    },
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        if (flowType === authConstants.CHANGE_PASSWORD) {
                            showOtpFlow();
                        }
                        if (flowType === authConstants.CHANGE_MOBILE_NUMBER) {
                            showOtpMobileFlow();
                        }
                        return sendOTPAfterLoginComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const changePasswordEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_CHANGE_PASSWORD_REQUEST),
        mergeMap((action) => {
            const { showOtpFlow, ...payload } = action.payload;
            return ajax
                .post(
                    "/api/auth/changePassword",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        if (payload?.type === authConstants.CHANGE_PASSWORD) {
                            if (ajaxResponse.response.data.otpRequired) {
                                return of(
                                    sendOTPAfterLoginRequest({
                                        rememberBrowser: false,
                                        timeStamp:
                                            ajaxResponse.response.data
                                                .timeStamp,
                                        browserFingerprint:
                                            payload.browserFingerprint,
                                        otpTypeId:
                                            otpTypeConstants.AUTH_TYPE_CHANGE_PASSWORD,
                                        flowType: authConstants.CHANGE_PASSWORD,
                                        showOtpFlow,
                                    }),

                                    changePasswordPreAuthDetails({
                                        ...payload,
                                        ...ajaxResponse.response,
                                    }),
                                );
                            }
                        } else {
                            showOtpFlow();
                            return of(
                                changePasswordComplete(ajaxResponse.response),
                            );
                        }
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const changeMobileNumberEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_CHANGE_MOBILE_NUMBER_REQUEST),
        mergeMap((action) => {
            const { showOtpMobileFlow, ...payload } = action.payload;
            return ajax
                .post(
                    "/api/auth/changeMobileNumber",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        if (
                            payload?.type === authConstants.CHANGE_MOBILE_NUMBER
                        ) {
                            if (ajaxResponse.response.data.otpRequired) {
                                return of(
                                    sendOTPAfterLoginRequest({
                                        rememberBrowser: false,
                                        timeStamp:
                                            ajaxResponse.response.data
                                                .timeStamp,
                                        browserFingerprint:
                                            payload.browserFingerprint,
                                        otpTypeId:
                                            otpTypeConstants.AUTH_TYPE_CHANGE_MOBILE_NUMBER,
                                        flowType:
                                            authConstants.CHANGE_MOBILE_NUMBER,
                                        showOtpMobileFlow,
                                    }),

                                    changePasswordPreMobileDetails({
                                        ...payload,
                                        ...ajaxResponse.response,
                                    }),
                                );
                            }
                        } else {
                            showOtpMobileFlow();
                            return of(
                                changeMobileNumberComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        }
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const forgotPasswordEmailVeryficationEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST),
        mergeMap((action) => {
            const { form, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/auth/forgotPasswordEmailVerify",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        form.reset();
                        return forgotPasswordEmailVeryficationComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const profilePictureUploadEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_CHANGE_PROFILE_PICTURE_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/auth/upload-profile-pic",
                    action.payload.formData,
                    getRequestHeader(requestTypes.REQUEST_TYPE_FILE_UPLOAD),
                )
                .pipe(
                    map((ajaxResponse) =>
                        profilePictureUploadComplete(ajaxResponse.response),
                    ),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const profileNotificationChangeEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_CHANGE_NOTIFICATION_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/auth/change-notification",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return profileNotificationChangeComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const changeProfileNameEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_CHANGE_PROFILE_NAME_REQUEST),
        mergeMap((action) => {
            const { setNameEditMode, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/auth/change-profile-name",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        setNameEditMode(false);
                        return of(
                            getParticipantProfileRequest(),
                            changeProfileNameComplete(ajaxResponse.response),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const profileChangeHomeAddressEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_CHANGE_HOME_ADDRESS_REQUEST),
        mergeMap((action) => {
            const { setAddressEditMode, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/auth/change-home-address",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        setAddressEditMode(false);
                        return of(
                            getParticipantProfileRequest(),
                            profileChangeHomeAddressComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getUserDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_GET_USER_DETAILS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/auth/get-user-details",
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getUSerDetailsComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getParticipantProfileEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_GET_PARTICIPANT_PROFILE_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/auth/get-participant-profile",
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        if (ajaxResponse?.response?.data?.participantIds[0]) {
                            if (
                                participantTypeIds.TLC_PARTICIPANT ==
                                ajaxResponse?.response?.data.roleId
                            ) {
                                return of(
                                    getParticipantProfileComplete(
                                        ajaxResponse.response,
                                    ),
                                );
                            } else if(ajaxResponse?.response?.data?.jobRoleId === 20){
                                    return of(
                                        campaignGetAreaManagerDealersRequest({
                                            particpantId:
                                                ajaxResponse?.response?.data
                                                    ?.participantIds[0],
                                            areaId:ajaxResponse?.response?.data?.area === "0" ? "11" : ajaxResponse?.response?.data?.area
                                        }),
                                        getParticipantProfileComplete(
                                            ajaxResponse.response,
                                        ),
                                    );
                                } else {
                                    return of(
                                        getParticipantProfileComplete(
                                            ajaxResponse.response,
                                        ),
                                    );
                                }
                        } else {
                            return of(
                                getParticipantProfileComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        }
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const subscribeEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_SUBSCRIBE_REQUEST),
        mergeMap((action) => {
            const { showMessage, ...payload } = action.payload;
            return ajax
                .post(
                    "/api/auth/subscribe",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        showMessage();
                        return of(
                            getParticipantProfileRequest(),
                            subscribeComplete(ajaxResponse.response),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const userDeviceEpic = (actions$) => {
    return actions$.pipe(
        ofType(authConstants.AUTH_USER_DEVICE_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/auth/device",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return userDeviceComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};


const clearCookieData = () => {
    const cookies = document.cookie.split(";");

    cookies.forEach((cookie) => {
        const eqPos = cookie.indexOf("=");
        const name =
            eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
};
